/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeviceTokenCreate,
  HTTPValidationError,
} from '../models/index';
import {
    DeviceTokenCreateFromJSON,
    DeviceTokenCreateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface ApiAddDeviceTokenV2DeviceTokenPostRequest {
    deviceTokenCreate: DeviceTokenCreate;
}

/**
 * 
 */
export class DeviceTokensApi extends runtime.BaseAPI {

    /**
     * Permet d\'ajouter un token dans la base de données.
     * Api Add Device Token
     */
    async apiAddDeviceTokenV2DeviceTokenPostRaw(requestParameters: ApiAddDeviceTokenV2DeviceTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceTokenCreate'] == null) {
            throw new runtime.RequiredError(
                'deviceTokenCreate',
                'Required parameter "deviceTokenCreate" was null or undefined when calling apiAddDeviceTokenV2DeviceTokenPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/deviceToken`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceTokenCreateToJSON(requestParameters['deviceTokenCreate']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet d\'ajouter un token dans la base de données.
     * Api Add Device Token
     */
    async apiAddDeviceTokenV2DeviceTokenPost(requestParameters: ApiAddDeviceTokenV2DeviceTokenPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiAddDeviceTokenV2DeviceTokenPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
